/* Zellaforte funnel instrumentation (zf_* events).

   One fan-out helper (window.zfTrack) → dataLayer (always; GTM gates its own
   tags), PostHog (window.posthog only exists after analytics consent — see
   snippets/posthog.liquid), and Meta ONLY when the caller passes an explicit
   meta mapping (snippets/meta-product-events.liquid owns ViewContent/AddToCart;
   the Meta events fired from here are InitiateCheckout and, for pharmacy
   click-outs, FindLocation).

   Cart state is seeded server-side via window.__zfCartSeed (snippets/
   zf-analytics.liquid) and updated from every cartUpdate publish, so events
   carry cart_value/item_count without extra fetches.

   Checkout-page events (zfp_*) come from the Shopify Custom Pixel
   (docs/pixels/customer-events-pixel.js), not from this file. */
(function () {
  var seed = window.__zfCartSeed || {};
  var state = {
    currency: seed.currency || 'EUR',
    item_count: seed.item_count || 0,
    total_price: seed.total_price || 0, // cents
    has_subscription: !!seed.has_subscription,
    items: seed.items || {} // variant_id -> quantity
  };
  var lastCheckoutClick = 0;

  function hasMarketingConsent() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)avada_cookie_consent=([^;]+)/);
      if (!m) return false;
      var c = JSON.parse(decodeURIComponent(m[1]));
      return c && c.marketing === true;
    } catch (e) { return false; }
  }

  function eventId(prefix) {
    return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 10);
  }

  function cartProps() {
    return {
      currency: state.currency,
      cart_value: state.total_price / 100.0,
      cart_item_count: state.item_count
    };
  }

  function zfTrack(name, props, meta, options) {
    var id = eventId(name);
    var context = options && options.includeCart === false ? {} : cartProps();
    var payload = Object.assign({}, context, props || {});
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name, event_id: id }, payload));
    } catch (e) {}
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, payload);
      }
    } catch (e) {}
    try {
      if (meta && meta.event && hasMarketingConsent() && typeof window.fbq === 'function') {
        window.fbq('track', meta.event, meta.params || {}, { eventID: id });
      }
    } catch (e) {}
    return id;
  }
  window.zfTrack = zfTrack;
  window.zfEventId = eventId;

  /* /cart/add.js returns only the ADDED line(s); /cart/change|update.js return
     the FULL cart (token + item_count + total_price). Full shapes rebuild the
     snapshot; add shapes increment it. */
  function isFullCart(d) {
    return !!d && typeof d.item_count === 'number' && typeof d.total_price === 'number' && Array.isArray(d.items);
  }

  function addedItemsFrom(d) {
    if (!d) return [];
    var list = Array.isArray(d.items) ? d.items : (d.id ? [d] : []);
    return list.map(function (li) {
      var cents = (typeof li.final_line_price === 'number') ? li.final_line_price
                : ((li.price || 0) * (li.quantity || 1));
      return {
        variant_id: String(li.variant_id || li.id || ''),
        quantity: li.quantity || 1,
        value: cents / 100.0,
        selling_plan_id: (li.selling_plan_allocation && li.selling_plan_allocation.selling_plan && li.selling_plan_allocation.selling_plan.id) || li.selling_plan || null
      };
    });
  }

  function rebuildState(cart) {
    var items = {};
    var hasSub = false;
    cart.items.forEach(function (li) {
      var vid = String(li.variant_id || li.id);
      items[vid] = (items[vid] || 0) + (li.quantity || 0);
      if (li.selling_plan_allocation) hasSub = true;
    });
    state = { currency: cart.currency || state.currency, item_count: cart.item_count, total_price: cart.total_price, has_subscription: hasSub, items: items };
  }

  function applyAdd(added) {
    added.forEach(function (i) {
      if (!i.variant_id) return;
      state.items[i.variant_id] = (state.items[i.variant_id] || 0) + i.quantity;
      state.item_count += i.quantity;
      state.total_price += Math.round(i.value * 100);
      if (i.selling_plan_id) state.has_subscription = true;
    });
  }

  var ADD_SOURCES = ['product-form', 'kb-buybox', 'quick-add'];

  function onCartUpdate(evt) {
    if (!evt || !evt.source) return;
    var d = evt.cartData;

    if (ADD_SOURCES.indexOf(evt.source) !== -1) {
      var added = addedItemsFrom(d);
      if (isFullCart(d)) rebuildState(d); else applyAdd(added);
      var value = added.reduce(function (s, i) { return s + (i.value || 0); }, 0);
      var first = added[0] || {};
      zfTrack('zf_add_to_cart', {
        source: evt.source,
        variant_id: first.variant_id || null,
        selling_plan_id: first.selling_plan_id || null,
        purchase_type: first.selling_plan_id ? 'subscription' : 'one_time',
        quantity: added.reduce(function (s, i) { return s + (i.quantity || 0); }, 0) || 1,
        value: value
      });
      return;
    }

    if (evt.source === 'cart-items' && isFullCart(d)) {
      var before = state.items;
      var beforeState = state;
      rebuildState(d);
      var vid, diffed = false;
      for (vid in before) {
        var now = state.items[vid] || 0;
        if (now === 0) {
          zfTrack('zf_cart_item_removed', { variant_id: vid });
          diffed = true;
        } else if (now !== before[vid]) {
          zfTrack('zf_cart_qty_changed', { variant_id: vid, direction: now > before[vid] ? 'increase' : 'decrease', new_quantity: now });
          diffed = true;
        }
      }
      if (!diffed && d.item_count !== beforeState.item_count) {
        zfTrack('zf_cart_qty_changed', { direction: d.item_count > beforeState.item_count ? 'increase' : 'decrease', new_quantity: d.item_count });
      }
      return;
    }

    // Other publishers (cart-abo-upsell etc.): keep the snapshot fresh, no event here.
    if (isFullCart(d)) rebuildState(d);
  }

  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      return true;
    }
    return false;
  }
  if (!bind()) document.addEventListener('DOMContentLoaded', bind);

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var checkoutBtn = e.target.closest('#CartDrawer-Checkout, #checkout');
    if (checkoutBtn) {
      // Validation failures re-submit the same form — don't double-count re-clicks.
      if (Date.now() - lastCheckoutClick < 5000) return;
      lastCheckoutClick = Date.now();
      var value = state.total_price / 100.0;
      var ecommerceItems = Object.keys(state.items).map(function (vid) {
        return { item_id: vid, quantity: state.items[vid] };
      });
      var id = zfTrack('zf_checkout_started', {
        placement: checkoutBtn.id === 'CartDrawer-Checkout' ? 'drawer' : 'cart_page',
        value: value,
        item_count: state.item_count,
        has_subscription: state.has_subscription
      }, {
        event: 'InitiateCheckout',
        params: { value: value, currency: state.currency, num_items: state.item_count }
      });
      try {
        window.dataLayer.push({
          event: 'begin_checkout',
          event_id: id,
          ecommerce: { currency: state.currency, value: value, items: ecommerceItems }
        });
      } catch (err) {}
      return;
    }

    var pharmLink = e.target.closest('[data-zf-pharmacy]');
    if (pharmLink) {
      var pharmacyName = pharmLink.getAttribute('data-zf-pharmacy') || 'unknown';
      var pharmacyPlacement = pharmLink.getAttribute('data-zf-placement') || 'unknown';
      /* Meta bekommt den Apotheken-Klick als Standard-Event FindLocation:
         Custom Events kommen auf Health-Pixeln nicht an, und FindLocation ist
         auf diesem Pixel sonst unbenutzt. Keine URL an Meta (Produktname). */
      zfTrack('zf_pharmacy_clickout', {
        pharmacy: pharmacyName,
        placement: pharmacyPlacement,
        url: pharmLink.href || null
      }, {
        event: 'FindLocation',
        params: { pharmacy: pharmacyName, placement: pharmacyPlacement }
      });
      return;
    }

    /* LP-Ausloeser (snippets/kb-pharmacy-drawer.liquid). Eigener Zweig statt
       Erweiterung des Selektors unten: die PDP leitet ihr placement aus
       isTrusted ab, die LP liest es aus data-zf-placement — zwei verschiedene
       Quellen, deshalb zwei Zweige. Steht VOR dem #zf-pharm-btn-Zweig, damit
       ein LP-Ausloeser nie faelschlich als pdp_buybox gezaehlt wird. */
    var drawerTrigger = e.target.closest('[data-zf-pharm-drawer-trigger]');
    if (drawerTrigger) {
      zfTrack('zf_pharmacy_drawer_opened', {
        placement: drawerTrigger.getAttribute('data-zf-placement') || 'unknown'
      });
      return;
    }

    if (e.target.closest('#zf-pharm-btn')) {
      /* Bisher ohne Props — damit liessen sich Öffnungen aus der Buy Box nicht
         von denen aus der Sticky-Leiste unterscheiden. Über closest() geht das
         nicht: sections/sticky-atc.liquid ruft .click() auf DEMSELBEN Button
         auf, das Event-Ziel ist also in beiden Fällen identisch. Ein
         programmatischer Klick ist aber nie isTrusted — das trennt sie sauber. */
      zfTrack('zf_pharmacy_drawer_opened', {
        placement: e.isTrusted ? 'pdp_buybox' : 'sticky_atc'
      });
    }
  });
})();
